import * as dictionary from '../config/dictionary'

const generateRandomName = () => {
    var adjective = dictionary.adjectives[Math.floor(Math.random() * dictionary.adjectives.length)];
    var animal = dictionary.animals[Math.floor(Math.random() * dictionary.animals.length)];
    var color = dictionary.colors[Math.floor(Math.random() * dictionary.colors.length)];

    return color + "_" + adjective + "_" + animal;
}

export default generateRandomName;
    